// eslint-disable-next-line max-len
export const fatZebraIdenPt = String(
  process.env.REACT_APP_FAT_ZEBRA_CARD_TOKEN_DECRYPTION_PRIVATE_KEY
);
